export const generateJiraSAINSearchUrl = (query: string, jql?: string): string => {
	const trimmedQuery = query.trim();

	if (jql) {
		return `/issues/?jql=${encodeURIComponent(jql)}&text=${encodeURIComponent(trimmedQuery)}&referrer=sain`;
	}

	const params = new URLSearchParams({ searchString: trimmedQuery, referrer: 'sain' });
	return `/jira/search?${params.toString()}`;
};
